/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkCloseLoanCommand } from '../models/BulkCloseLoanCommand';
import type { CloseLoanCommand } from '../models/CloseLoanCommand';
import type { CreateLoanCommand } from '../models/CreateLoanCommand';
import type { DailyInterest } from '../models/DailyInterest';
import type { DeleteLoanByIdCommand } from '../models/DeleteLoanByIdCommand';
import type { EditLoanCommand } from '../models/EditLoanCommand';
import type { LoanDto } from '../models/LoanDto';
import type { LoanHistoryDetailDto } from '../models/LoanHistoryDetailDto';
import type { LoanHistoryDto } from '../models/LoanHistoryDto';
import type { LoanListDtoPaginatedResult } from '../models/LoanListDtoPaginatedResult';
import type { LoanSummaryDto } from '../models/LoanSummaryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LoansService {
    /**
     * @param loanId
     * @returns LoanHistoryDto OK
     * @throws ApiError
     */
    public static getApiLoansHistory(
        loanId: string,
    ): CancelablePromise<Array<LoanHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Loans/{loanId}/history',
            path: {
                'loanId': loanId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param entityId
     * @param validTo
     * @param type
     * @param timeZone
     * @returns LoanHistoryDetailDto OK
     * @throws ApiError
     */
    public static getApiLoansHistory1(
        entityId: string,
        validTo?: string,
        type?: string,
        timeZone?: string,
    ): CancelablePromise<Array<LoanHistoryDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Loans/history/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'ValidTo': validTo,
                'Type': type,
                'TimeZone': timeZone,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiLoans(
        id: string,
        requestBody?: DeleteLoanByIdCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Loans/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static patchApiLoans(
        id: string,
        requestBody?: EditLoanCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/Loans/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns LoanDto OK
     * @throws ApiError
     */
    public static getApiLoans(
        id: string,
    ): CancelablePromise<LoanDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Loans/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param pageNumber
     * @param pageSize
     * @param filterByBusinessUnit
     * @param filterByStatus
     * @param filterByBank
     * @param filterByLoanType
     * @param filterByStartDateStart
     * @param filterByStartDateEnd
     * @param filterByDueDateStart
     * @param filterByDueDateEnd
     * @param sortBy
     * @param sortOrder
     * @returns LoanListDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiLoans1(
        pageNumber?: number,
        pageSize?: number,
        filterByBusinessUnit?: Array<string>,
        filterByStatus?: Array<string>,
        filterByBank?: Array<string>,
        filterByLoanType?: Array<string>,
        filterByStartDateStart?: string,
        filterByStartDateEnd?: string,
        filterByDueDateStart?: string,
        filterByDueDateEnd?: string,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<LoanListDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Loans',
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'FilterByBusinessUnit': filterByBusinessUnit,
                'FilterByStatus': filterByStatus,
                'FilterByBank': filterByBank,
                'FilterByLoanType': filterByLoanType,
                'FilterByStartDateStart': filterByStartDateStart,
                'FilterByStartDateEnd': filterByStartDateEnd,
                'FilterByDueDateStart': filterByDueDateStart,
                'FilterByDueDateEnd': filterByDueDateEnd,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiLoans(
        requestBody?: CreateLoanCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Loans',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param selectedLoans
     * @param unselectedLoans
     * @param filterByLoanType
     * @param filterByBusinessUnit
     * @param filterByBank
     * @param filterByStartDateStart
     * @param filterByStartDateEnd
     * @param filterByDueDateStart
     * @param filterByDueDateEnd
     * @param filterByStatus
     * @param sortBy
     * @param sortOrder
     * @param timeZone
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiLoansExport(
        selectedLoans?: Array<string>,
        unselectedLoans?: Array<string>,
        filterByLoanType?: Array<string>,
        filterByBusinessUnit?: Array<string>,
        filterByBank?: Array<string>,
        filterByStartDateStart?: string,
        filterByStartDateEnd?: string,
        filterByDueDateStart?: string,
        filterByDueDateEnd?: string,
        filterByStatus?: Array<string>,
        sortBy?: string,
        sortOrder?: string,
        timeZone?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Loans/export',
            query: {
                'SelectedLoans': selectedLoans,
                'UnselectedLoans': unselectedLoans,
                'FilterByLoanType': filterByLoanType,
                'FilterByBusinessUnit': filterByBusinessUnit,
                'FilterByBank': filterByBank,
                'FilterByStartDateStart': filterByStartDateStart,
                'FilterByStartDateEnd': filterByStartDateEnd,
                'FilterByDueDateStart': filterByDueDateStart,
                'FilterByDueDateEnd': filterByDueDateEnd,
                'FilterByStatus': filterByStatus,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'TimeZone': timeZone,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static patchApiLoansClose(
        id: string,
        requestBody?: CloseLoanCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/Loans/{id}/close',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @returns LoanSummaryDto OK
     * @throws ApiError
     */
    public static getApiLoansSummary(): CancelablePromise<LoanSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Loans/summary',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param startDate
     * @param endDate
     * @param loanId
     * @param timeZone
     * @returns DailyInterest OK
     * @throws ApiError
     */
    public static getApiLoansDailyInterest(
        startDate?: string,
        endDate?: string,
        loanId?: string,
        timeZone?: string,
    ): CancelablePromise<Array<DailyInterest>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Loans/DailyInterest',
            query: {
                'StartDate': startDate,
                'EndDate': endDate,
                'LoanId': loanId,
                'TimeZone': timeZone,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiLoansCloseBulk(
        requestBody?: BulkCloseLoanCommand,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Loans/close-bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns string OK
     * @throws ApiError
     */
    public static postApiLoansCloseUndo(
        id: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Loans/{id}/close/undo',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
